module.exports = __webpack_public_path__ + "img/poter2.737991d1.jpg";